
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTidalIec as ObiTidalIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-tidal-iec.js';
 
 
 

 
 export const ObiTidalIec = createComponent({
   react: React,
   tagName: 'obi-tidal-iec',
   elementClass: ObiTidalIecElement,
   events: {
     
   }
  });
 
 